import { sendFilesToS3ByPresignedPost } from "services/filesRequests";
import { InstructionStep, PresignedPost } from "utils/interfaces";

/**
 * Function used to upload step-by-step instruction images
 * to S3 using presigned POST URLs.
 * Iterates over each instruction step and uploads both `stepImage` and
 * `codeSoFarImage` (if present), storing them under the path
 * `{platform}/{lessonToAdd}/{lessonId}/instructions/{hash}`.
 * @param stepByStepInstructions - Array of instruction steps containing optional images to upload.
 * @param instructionUrls - Map of image hash to its corresponding presigned POST data.
 * @param lessonToAdd - The lesson type/category used to build the S3 path.
 * @param lessonId - The lesson ID used to build the S3 path.
 */
export const sendInstructionImagesToS3 = async ({
  platform,
  stepByStepInstructions,
  instructionUrls,
  lessonToAdd,
  lessonId,
}: {
  platform: string | undefined;
  stepByStepInstructions: InstructionStep[];
  instructionUrls: { [key: string]: PresignedPost } | undefined;
  lessonToAdd: string;
  lessonId: string;
}) => {
  // Upload the instruction images (if defined)
  if (
    platform &&
    stepByStepInstructions &&
    stepByStepInstructions.length > 0 &&
    instructionUrls
  ) {
    // Going step by step
    await Promise.all(
      stepByStepInstructions.map(async (instruction: InstructionStep) => {
        // Check if the stepImage is defined
        if (
          instruction &&
          instruction.stepImage &&
          instruction.stepImage.content
        ) {
          // Get the hash
          const hash = instruction.stepImage.hash;

          // Try to get the presigned post url from the response
          const presignedUrl = instructionUrls[hash];

          // Check if a presigned url has been obtained
          if (presignedUrl) {
            await sendFilesToS3ByPresignedPost(
              instruction.stepImage.content,
              `${platform}/${lessonToAdd}/${lessonId}/instructions/${hash}`,
              presignedUrl,
            );
          }
        }

        // Check if the codeSoFarImage is defined
        if (
          instruction &&
          instruction.codeSoFarImage &&
          instruction.codeSoFarImage.content
        ) {
          // Get the hash
          const hash = instruction.codeSoFarImage.hash;

          // Try to get the presigned post url from the response
          const presignedUrl = instructionUrls[hash];

          // Check if a presigned url has been obtained
          if (presignedUrl) {
            await sendFilesToS3ByPresignedPost(
              instruction.codeSoFarImage.content,
              `${platform}/${lessonToAdd}/${lessonId}/instructions/${hash}`,
              presignedUrl,
            );
          }
        }
      }),
    );
  }
};
